const listenToPrivacyPolicyCheckboxUpdates = require("./listenToPrivacyPolicyCheckboxUpdates");

/**
 * @param onUpdate {(checkbox: HTMLInputElement) => void}
 * @return {void}
 */
module.exports = function initPrivacyPolicyCheckboxes(onUpdate) {
    listenToPrivacyPolicyCheckboxUpdates(onUpdate)
}